/* Party LP (sections/party-lp.liquid). Ported from Sidestreet_Party_LP.html; age gate removed per client. */
(function () {
  const root = document.querySelector('.plp');
  if (!root) return;
  const $ = (s) => root.querySelector(s),
    $$ = (s) => [...root.querySelectorAll(s)];
  const d = root.dataset;

  $$('[data-scroll]').forEach((b) => (b.onclick = () => document.getElementById(b.dataset.scroll).scrollIntoView({ behavior: 'smooth' })));

  /* plan + CTAs */
  // No selling plan on the variant: only one-time purchase is possible.
  let plan = d.sellingPlan ? 'sub' : 'one';
  const sub = $('#subOpt'),
    once = $('#onceLink'),
    cta = $('#ctaBtn'),
    err = $('#ctaErr');
  function render() {
    const s = plan === 'sub';
    sub.setAttribute('aria-checked', s);
    once.setAttribute('aria-pressed', !s);
    once.textContent = s ? 'or buy once for ' + d.onePrice : 'Buying once for ' + d.onePrice + ' · switch back to 50% off';
    $('#sp').textContent = s ? d.subPrice : d.onePriceFull;
    $('#sl').textContent = s ? '+ 20% off for life' : 'One-time';
    cta.textContent = s ? 'GET 50% OFF NOW →' : 'BUY ONCE · ' + d.onePrice + ' →';
    $('#stickyCta').textContent = s ? 'GET 50% OFF' : 'BUY NOW';
  }
  if (d.sellingPlan) {
    sub.onclick = () => {
      plan = 'sub';
      render();
    };
    once.onclick = () => {
      plan = plan === 'one' ? 'sub' : 'one';
      render();
    };
  } else {
    sub.hidden = once.hidden = true;
  }

  function checkoutUrl() {
    // UTM passthrough: carry ad params to checkout
    const u = new URL('/checkout', location.href),
      q = new URLSearchParams(location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'gclid'].forEach((k) => {
      if (q.get(k)) u.searchParams.set(k, q.get(k));
    });
    const to = u.pathname + u.search;
    // /discount/CODE sets the code for checkout (cart permalinks drop selling_plan, so they can't be used here)
    return plan === 'sub' && d.discount ? '/discount/' + encodeURIComponent(d.discount) + '?redirect=' + encodeURIComponent(to) : to;
  }
  const post = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    });
  // Cart is cleared first so repeat clicks never stack units.
  async function goCheckout(e) {
    e.preventDefault();
    const a = e.currentTarget;
    const item = { id: Number(d.variant), quantity: 1 };
    if (plan === 'sub') item.selling_plan = Number(d.sellingPlan);
    a.setAttribute('aria-busy', 'true');
    err.hidden = true;
    try {
      await post('/cart/clear.js');
      const r = await post('/cart/add.js', { items: [item] });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Could not add to cart.');
      location.href = checkoutUrl();
    } catch (x) {
      a.removeAttribute('aria-busy');
      err.textContent = x.message;
      err.hidden = false;
      document.getElementById('heroCta').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  $$('.js-cta').forEach((a) => a.addEventListener('click', goCheckout));
  render();

  /* gallery dots */
  const slides = $('#slides'),
    dotWrap = $('#dots'),
    n = slides.children.length;
  for (let i = 0; i < n; i++) {
    const b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + n);
    b.onclick = () => slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
    dotWrap.appendChild(b);
  }
  const dots = [...dotWrap.children];
  function syncDots() {
    const i = Math.round(slides.scrollLeft / slides.clientWidth);
    dots.forEach((dt, j) => dt.setAttribute('aria-current', i === j));
    $('.promo').classList.toggle('off', !!slides.children[i] && slides.children[i].classList.contains('s-ad'));
  }
  slides.addEventListener('scroll', syncDots, { passive: true });
  syncDots();

  /* sticky buy bar: show whenever the hero CTA is off-screen, hide at final CTA */
  const st = $('#sticky'),
    stCta = $('#stickyCta');
  let heroVis = true,
    finalVis = false;
  function upd() {
    const show = !heroVis && !finalVis;
    st.classList.toggle('show', show);
    st.setAttribute('aria-hidden', !show);
    stCta.tabIndex = show ? 0 : -1;
  }
  new IntersectionObserver(([e]) => {
    heroVis = e.isIntersecting;
    upd();
  }).observe($('#heroCta'));
  new IntersectionObserver(
    ([e]) => {
      finalVis = e.isIntersecting;
      upd();
    },
    { threshold: 0.25 }
  ).observe($('#final'));
})();
